var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "vSelect",
    _vm._b(
      {
        attrs: {
          options: _vm.options,
          label: "name",
          reduce: e => e.id,
          value: _vm.value,
          multiple: _vm.multiple,
          clearable: _vm.clearable
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        }
      },
      "vSelect",
      _vm.binds,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }